import type { TourStep } from '../types';

export const creatingTeamSteps: TourStep[] = [
  {
    target: '[data-tour="team-section"]',
    title: 'Team Management',
    content:
      'Ashlar supports teams so appraisal firms can collaborate — share appraisals, coordinate schedules, and manage assignments together.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="team-create"]',
    title: 'Create Your Team',
    content:
      'Click here to create a team. Enter your firm name and description. As the creator, you\'ll be the team owner with full admin rights.',
    placement: 'bottom',
    isActionStep: true,
    spotlightClicks: true,
    nextButtonText: 'I\'ll do this later',
  },
  {
    target: '[data-tour="team-members"]',
    title: 'Team Members',
    content:
      'Once created, all members appear here with their roles, join dates, and statuses. You can manage individual members and change roles.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="team-settings"]',
    title: 'Team Settings',
    content:
      'Configure team name, description, and default sharing preferences. Only team owners and admins can access these settings.',
    placement: 'bottom',
    spotlightClicks: true,
  },
];
